/* What an item is SHOWN as, decided once for both clients (ADR 0049 §1).
 *
 * `media_type` is what the item is (ADR 0029): `video` plays, `image` is shown
 * as its stored stills. Only `image` takes the stills path — every other value,
 * including one a future source invents before a client has heard of it, keeps
 * the player. The player already has a failure state for "this would not play";
 * a stills surface handed an item with no stills would have nothing to say.
 *
 * Typed structurally rather than against `Item`, so this package keeps no
 * dependency on the generated API types.
 */

/** An image post: shown as stills, never resolved or prefetched as video. */
export const isStillsItem = (item: { media_type: string }): boolean =>
  item.media_type === 'image';

/** A post of more than one picture — what the native Library tile marks
 *  (ADR 0049 §8). A one-picture post is unmarked, and so is every reel. */
export const isMultiPicture = (item: {
  media_type: string;
  media_count: number;
}): boolean => isStillsItem(item) && item.media_count > 1;
